import React, { useState, useEffect, useContext } from "react";
import DataTableComponent from "react-data-table-component";

import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";

import Templete from "../Templete/Templete";
import AuthService from "../../../services/User/AuthService";
import RechargeService from "../../../services/User/RechargeService";
import HttpError from "../../../utill/HttpError";
import LoadingContext from "../../../store/loading-context";

const MyCommission = () => {
  const loadingCtx = useContext(LoadingContext);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetch = async (order_id) => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await RechargeService.discountDetails(token);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setData(responseData.data.result);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);

      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const columns = [
    {
      name: "ID",
      cell: (row) => (
        <div>
          <span>{row.product_id}</span>
        </div>
      ),
    },
    {
      name: "Product/Service Name",
      cell: (row) => (
        <div>
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            {row.product.name}
          </span>
        </div>
      ),
    },
    {
      name: "Slab Details",
      cell: (row) => (
        <div>
          <span>{row.slab_start + " - " + row.slab_end}</span>
        </div>
      ),
    },
    {
      name: "Type",
      cell: (row) => (
        <div>
          <span>{row.type}</span>
        </div>
      ),
    },
    {
      name: "Commission",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            {row.type === "CHARGE" ? "-" : ""} {row.rt_amount}{" "}
            {row.calculation === "PERCENTAGE" ? "%" : ""}{" "}
          </span>
        </div>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Templete t1="Home" t2="My Commission">
        <section class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title">My Commission</h3>
                  </div>

                  <div class="card-body">
                    <DataTableComponent
                      noHeader={true}
                      columns={columns}
                      data={data}
                      progressPending={loading}
                      highlightOnHover
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>
    </React.Fragment>
  );
};

export default MyCommission;
